import React from "react";
import { TabPanel, TabView } from "primereact/tabview";
import useSessionState from "../../hooks/useSessionState";
import Requisicion from "./requisicion";
import constantes from "../../catalogos/constantes";
import useSeguridad from "../../Seguridad/useSeguridad";
import Almacen from "../mantenimiento/almacen/almacen";

const RequisicionesSecciones = () => {
    const seguridad = useSeguridad();

    const soloLectura = !seguridad.esEditable(constantes.menus.requisiciones);
    const soloLecturaAlmacen = !seguridad.esEditable(constantes.menus.almacen);

    const [activeIndex, setActiveIndex] = useSessionState('tabSeguimiento', 0);

    return (
        <>
            <TabView 
                activeIndex={activeIndex} 
                onTabChange={(e) => setActiveIndex(e.index)} 
                className="main-tab-view"
            >
                <TabPanel  
                    headerStyle={
                        (seguridad.tieneAcceso(constantes.menus.requisicionesSeccion) || soloLectura) 
                            ? { display: "inline" } 
                            : { display: "none" }
                    } 
                    header="Requisiciones"
                >
                    <Requisicion 
                        esSeccionAutorizar={false} 
                        soloLectura={soloLectura}  
                    />
                </TabPanel>

                <TabPanel  
                    headerStyle={
                        seguridad.tieneAcceso(constantes.menus.requisicionesPorAutorizar) 
                            ? { display: "inline" } 
                            : { display: "none" }
                    } 
                    header="Requisiciones por Autorizar"
                >
                    <Requisicion 
                        esSeccionAutorizar={true} 
                        soloLectura={soloLectura}
                    />
                </TabPanel>

                <TabPanel  
                    headerStyle={
                        seguridad.tieneAcceso(constantes.menus.almacen) 
                            ? { display: "inline" } 
                            : { display: "none" }
                    } 
                    header="Almacén"
                >
                    <Almacen soloLectura={soloLecturaAlmacen} />
                </TabPanel>
            </TabView>
        </>
    )
};

export default RequisicionesSecciones;